module.exports = __webpack_public_path__ + "static/media/icon-instore.5fcffbbd.svg";